export type ImportanceOption = {
  id: number;
  value: "Low" | "Normal" | "High" | "Unknown";
};

export const importanceOptions: ImportanceOption[] = [
  { id: 1, value: "Low" },
  { id: 2, value: "Normal" },
  { id: 3, value: "High" },
  { id: 4, value: "Unknown" },
];
